export default {

  doAverage (data, query, numeratorField, denominatorField, useMulti) {
    var statNum = []
    var statDen = []

    if (useMulti) {
      numeratorField += (query.organMode === 'multi' ? '_multi' : '_single')
      denominatorField += (query.organMode === 'multi' ? '_multi' : '_single')
    }

    data.forEach(function (item) {
      let groupId

      switch (query.regionMode) {
        case 'opo':
          groupId = item.opo_id
          break
        case 'state':
          groupId = item.state
          break
        case 'unos':
          groupId = item.unos_id
      }

      if (!groupId) {
        return
      }
      if (item.year !== query.year) {
        return
      }
      if (!statNum[groupId]) {
        statNum[groupId] = 0
      }
      if (!statDen[groupId]) {
        statDen[groupId] = 0
      }
      statNum[groupId] += item[numeratorField]
      statDen[groupId] += item[denominatorField]
    })

    var stat = []
    for (let k in statDen) {
      stat[k] = statNum[k] / statDen[k]
    }

    return stat
  },

  /**
   * Probability of receiving a transplant.
   *
   * @param data
   * @param query
   * @returns {Array}
   */
  stat_1 (data, query) {
    return this.doAverage(data, query, 'recipients', 'candidates', true)
  },

  /**
   * Declined offers for quality reasons
   *
   * @param data
   * @param query
   * @returns {Array}
   */
  stat_2 (data, query) {
    return this.doAverage(data, query, 'offers_declined', 'offers', false)
  },

  stat_4 (data, query) {
    return this.doAverage(data, query, 'offers_accepted_lq', 'offers_accepted', false)
  },

  stat_5 (data, query) {
    return this.doAverage(data, query, 'offers_accepted_mq', 'offers_accepted', false)
  },

  stat_6 (data, query) {
    return this.doAverage(data, query, 'offers_accepted_hq', 'offers_accepted', false)
  },

  stat_7 (data, query) {
    return this.doAverage(data, query, 'sumischemic', 'recipients', true)
  },

  /**
   * Average waiting time of a recipient who received a transplant.
   *
   * @param data
   * @param query
   * @returns {Array}
   */
  stat_8 (data, query) {
    return this.doAverage(data, query, 'sumwaiting', 'recipients', true)
  },

  /**
   * Post-mortality recipient rate of a recipient who received a transplant after {1, 3, 5} years.
   * Will be called by stat_9_1y, stat_9_3y, stat_9_5y.
   *
   * @param data
   * @param query
   * @param years
   */
  stat_9 (data, query, years) {
    return this.doAverage(data, query, 'dead' + years + 'yr', 'recipients', true)
  },

  stat_9_1 (data, query) {
    return this.stat_9(data, query, '1')
  },

  stat_9_3 (data, query) {
    return this.stat_9(data, query, '3')
  },

  stat_9_5 (data, query) {
    return this.stat_9(data, query, '5')
  },

  /**
   * Graft failure for a transplant after {1, 3, 5} years.
   * Will be called by stat_10_1y, stat_10_3y, stat_10_5y.
   *
   * @param data
   * @param query
   * @param years
   */
  stat_10 (data, query, years) {
    return this.doAverage(data, query, 'fail' + years + 'yr', 'recipients', true)
  },

  stat_10_1 (data, query) {
    return this.stat_10(data, query, '1')
  },

  stat_10_3 (data, query) {
    return this.stat_10(data, query, '3')
  },

  stat_10_5 (data, query) {
    return this.stat_10(data, query, '5')
  },

  stat_11 (data, query) {
    return this.doAverage(data, query, 'unused_organs', 'available_organs', false)
  },

  stat_12 (data, query) {
    return this.doAverage(data, query, 'declined_quality_organs', 'available_organs', false)
  }

}



// WEBPACK FOOTER //
// ./src/api/stats.js